import { render, staticRenderFns } from "./VDialogTransfer.vue?vue&type=template&id=ef53675c"
import script from "./VDialogTransfer.vue?vue&type=script&lang=js"
export * from "./VDialogTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports